__turbopack_context__.v({
  "article": "ArticleGrid-module__mV4B6W__article",
  "container": "ArticleGrid-module__mV4B6W__container",
  "fadeInItems": "ArticleGrid-module__mV4B6W__fadeInItems",
  "spacing--lg": "ArticleGrid-module__mV4B6W__spacing--lg",
  "spacing--md": "ArticleGrid-module__mV4B6W__spacing--md",
  "spacing--sm": "ArticleGrid-module__mV4B6W__spacing--sm",
  "spacing--xl": "ArticleGrid-module__mV4B6W__spacing--xl",
  "spacing--xs": "ArticleGrid-module__mV4B6W__spacing--xs",
  "spacing--xxl": "ArticleGrid-module__mV4B6W__spacing--xxl",
  "spacing--xxs": "ArticleGrid-module__mV4B6W__spacing--xxs",
  "spacing--xxxl": "ArticleGrid-module__mV4B6W__spacing--xxxl",
  "spacing--xxxs": "ArticleGrid-module__mV4B6W__spacing--xxxs",
});
